var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.272 12.001L12 18.667l-6.272-6.666a3.966 3.966 0 01-.855-1.445 4.033 4.033 0 01.33-3.283c.284-.49.668-.912 1.126-1.236a3.777 3.777 0 013.178-.573 3.83 3.83 0 011.47.767c.431.362.78.815 1.023 1.327a3.935 3.935 0 011.022-1.327 3.83 3.83 0 011.471-.768 3.777 3.777 0 013.178.574c.458.324.842.746 1.125 1.236a4.032 4.032 0 01.33 3.283 3.965 3.965 0 01-.854 1.445z",
    fill: "#703EFF",
    stroke: "#703EFF",
    strokeWidth: 1.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgHeartFilled;